
let create = () => import(/* webpackChunkName: "complaints" */ '@/views/complaints/Create');
let follow = () => import(/* webpackChunkName: "complaints" */ '@/views/complaints/FollowUp');
let show = () => import(/* webpackChunkName: "complaints" */ '@/views/complaints/Show');

export default [
    {
        path: "/complaints",
        redirect: "/complaints/create",
        component: () => import("@/views/complaints/Layout"),
        children: [
            {
                path: "create",
                name: "create",
                component: create,
                meta: {
                    title: "ثبت شکایات میهن شاپ ",
                    description:"در صورتی که درخواست از نوع شکایت دارید از طریق فرم شکایت اقدام نمایید تا پیگیری های مربوطه انجام شود."
                }
            },
            {
                path: "follow-up",
                name: "follow-up",
                component: follow,
                meta: {
                    title: "  پیگیری شکایات میهن شاپ ",
                    description: "   با وارد کردن کد پیگیری می توانید از وضعیت شکایت خود مطلع شوید ",
                }
            },
            {
                path: ":token",
                name: "complaint",
                component: show,
                meta: {
                    title: "پیام های شکایات میهن شاپ"
                }
            },
        ]
    }
]
